export default "__VITE_ASSET__0dd1789b__"